// No-op: data fetching now handled by LibraryContext.
// File kept to avoid touching Dashboard.js import. Safe to delete in future.
function FetchLibrary() {
  return null;
}

export default FetchLibrary;
